import styled from 'styled-components'
import { Thread } from 'styles/misc'
import { mq } from 'styles/mq'

export const Section = styled.section`
  &::before {
    ${Thread}
    right: 0;
    width: 57.1rem;
    aspect-ratio: 571 / 1327;
    mask-image: url("data:image/svg+xml,%3Csvg width='571' height='1327' viewBox='0 0 571 1327' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath d='M897.32 -280.032C861.87 -314.532 801.64 -310.712 759.86 -284.232C718.08 -257.752 690.76 -214.052 666.23 -171.092C567.35 2.07773 486.49 192.638 336.67 324.248C306.4 350.848 244.9 387.858 229.48 372.448C215.47 358.438 230.45 333.608 241.74 317.328C278.97 263.668 333.11 221.918 394.47 199.558C419.79 190.328 451.3 185.508 471.03 203.858C490.02 221.518 488.5 252.008 481.34 276.928C464.64 335.108 395.96 440.238 371.73 415.998C349.73 393.998 490.2 261.268 583.38 243.688C600.12 240.528 618.38 239.098 633.31 247.298C655.87 259.688 662.47 288.978 662.73 314.718C663.68 406.128 614.95 491.708 552.86 558.798C431.24 690.218 260.54 764.318 122.55 878.438C84.38 910.008 48.15 945.408 24.78 989.078C1.41 1032.75 -7.83 1085.98 9.32 1132.45C19.78 1160.8 39.26 1185 60.98 1206.01C127.1 1269.95 215.96 1307.79 307.08 1320.39C398.2 1332.99 491.53 1321.42 579.93 1296C739.28 1250.18 885.24 1158.71 995.95 1035.28' stroke='black' stroke-width='1.5' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");

    ${mq.ltLarge} {
      display: none;
    }
  }
`
